const csvCell = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value).replace(/\r?\n/g, ' ');
  return `"${text.replace(/"/g, '""')}"`;
};

export const downloadCsv = (filename, columns, rows) => {
  const header = columns.map((column) => csvCell(column.title)).join(',');
  const body = rows.map((row) => columns.map((column) => {
    const value = typeof column.render === 'function' ? column.render(row) : row[column.dataIndex];
    return csvCell(value);
  }).join(','));
  const blob = new Blob([`\uFEFF${[header, ...body].join('\n')}`], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const fetchAllPages = async (requestFn, params = {}, pageSize = 100) => {
  const allRows = [];
  let page = 1;
  let total = Number.POSITIVE_INFINITY;

  while (allRows.length < total) {
    const response = await requestFn({ ...params, page, pageSize, limit: pageSize });
    const data = response?.data || {};
    const rows = Array.isArray(data.data) ? data.data : [];
    allRows.push(...rows);
    total = Number(data.pagination?.total ?? data.total ?? rows.length);
    if (rows.length === 0 || rows.length < pageSize) break;
    page += 1;
  }

  return allRows;
};
